/* ===== ZEVA Theme JS ===== */

// ── Shopify AJAX Cart ─────────────────────────────────────────
async function zevaGetCart() {
  const r = await fetch('/cart.js');
  return r.json();
}

async function zevaAddToCart(variantId, qty) {
  qty = qty || 1;
  const r = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(variantId), quantity: qty })
  });
  if (!r.ok) {
    const e = await r.json();
    throw new Error(e.description || 'Could not add item');
  }
  return r.json();
}

async function zevaChangeCart(variantId, qty) {
  const r = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: String(variantId), quantity: qty })
  });
  return r.json();
}

// ── Badge + Drawer Update ─────────────────────────────────────
function updateBadge(cart) {
  const n = (cart && cart.item_count) ? cart.item_count : 0;
  document.querySelectorAll('.zeva-badge').forEach(function(el) {
    el.textContent = n;
    el.style.display = n > 0 ? 'inline-flex' : 'none';
  });
  const hc = document.getElementById('zevaDrawerCount');
  if (hc) hc.textContent = n > 0 ? ' (' + n + ')' : '';
}

function renderCartDrawer(cart) {
  const itemsEl = document.getElementById('zevaDrawerItems');
  const emptyEl = document.getElementById('zevaDrawerEmpty');
  const footerEl = document.getElementById('zevaDrawerFooter');
  const totalEl  = document.getElementById('zevaDrawerTotal');
  if (!itemsEl) return;

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '';
    emptyEl.style.display = 'flex';
    footerEl.style.display = 'none';
    return;
  }
  emptyEl.style.display = 'none';
  footerEl.style.display = 'block';

  itemsEl.innerHTML = cart.items.map(function(item) {
    var thumb = item.image
      ? '<img src="' + item.image + '" alt="' + item.product_title.replace(/"/g,'') + '">'
      : '<span style="font-size:22px;color:#C9A84C">✦</span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="zeva-cart-variant">' + item.variant_title + '</p>' : '';
    var price = 'R' + Math.round(item.final_line_price / 100);
    return '<div class="zeva-cart-row">' +
      '<div class="zeva-cart-thumb">' + thumb + '</div>' +
      '<div class="zeva-cart-meta">' +
        '<p class="zeva-cart-name">' + item.product_title + '</p>' +
        variant +
        '<div class="zeva-cart-bottom">' +
          '<div class="zeva-qty-ctrl">' +
            '<button onclick="zevaChange(\'' + item.variant_id + '\',' + (item.quantity - 1) + ')">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button onclick="zevaChange(\'' + item.variant_id + '\',' + (item.quantity + 1) + ')">+</button>' +
          '</div>' +
          '<span class="zeva-cart-price">' + price + '</span>' +
        '</div>' +
      '</div>' +
      '<button class="zeva-cart-del" onclick="zevaChange(\'' + item.variant_id + '\',0)" title="Remove">✕</button>' +
    '</div>';
  }).join('');

  if (totalEl) totalEl.textContent = 'R' + Math.round(cart.total_price / 100);
}

async function refreshCart() {
  var cart = await zevaGetCart();
  renderCartDrawer(cart);
  updateBadge(cart);
}

async function zevaChange(variantId, qty) {
  var cart = await zevaChangeCart(variantId, qty);
  renderCartDrawer(cart);
  updateBadge(cart);
}

// ── Cart Drawer Open/Close ────────────────────────────────────
function openCartDrawer() {
  document.getElementById('zevaDrawer').classList.add('open');
  document.getElementById('zevaOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}

function closeCartDrawer() {
  document.getElementById('zevaDrawer').classList.remove('open');
  if (!document.getElementById('zevaModalModal').classList.contains('open')) {
    document.getElementById('zevaOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }
}

function handleOverlayClick() {
  closeCartDrawer();
  closeVariantModal();
}

// ── Add To Cart (from product cards — single-variant) ─────────
async function addToCart(variantId) {
  try {
    await zevaAddToCart(variantId, 1);
    await refreshCart();
    openCartDrawer();
    showFlash();
  } catch(e) {
    alert(e.message || 'Could not add to cart. Please try again.');
  }
}

function showFlash() {
  var f = document.getElementById('zevaAddedFlash');
  if (!f) return;
  f.classList.add('show');
  setTimeout(function() { f.classList.remove('show'); }, 2000);
}

// ── Variant Modal ─────────────────────────────────────────────
var _product = null;

async function openVariantModal(handle) {
  try {
    var r = await fetch('/products/' + handle + '.js');
    var product = await r.json();
    _product = product;

    document.getElementById('zevaModalTitle').textContent = product.title;

    var imgEl = document.getElementById('zevaModalImg');
    imgEl.innerHTML = product.featured_image
      ? '<img src="' + product.featured_image + '" alt="' + product.title.replace(/"/g,'') + '">'
      : '<span style="font-size:28px;color:#C9A84C">✦</span>';

    var priceEl = document.getElementById('zevaModalPrice');
    var prices = product.variants.map(function(v){ return v.price; });
    var min = Math.min.apply(null, prices);
    var max = Math.max.apply(null, prices);
    priceEl.textContent = min === max
      ? 'R' + Math.round(min / 100)
      : 'R' + Math.round(min / 100) + ' – R' + Math.round(max / 100);

    var optsEl = document.getElementById('zevaModalOpts');
    optsEl.innerHTML = product.options.map(function(opt, gi) {
      return '<div class="zeva-opt-group">' +
        '<p class="zeva-opt-label">' + opt.name + '</p>' +
        '<div class="zeva-opt-btns">' +
          opt.values.map(function(val, oi) {
            return '<button class="zeva-opt-btn" data-g="' + gi + '" onclick="pickOpt(this,' + gi + ')">' + val + '</button>';
          }).join('') +
        '</div>' +
      '</div>';
    }).join('');

    document.getElementById('zevaModalError').style.display = 'none';
    document.getElementById('zevaModalModal').classList.add('open');
    document.getElementById('zevaOverlay').classList.add('open');
    document.body.style.overflow = 'hidden';
  } catch(e) {
    alert('Could not load product options. Please try again.');
  }
}

function closeVariantModal() {
  document.getElementById('zevaModalModal').classList.remove('open');
  if (!document.getElementById('zevaDrawer').classList.contains('open')) {
    document.getElementById('zevaOverlay').classList.remove('open');
    document.body.style.overflow = '';
  }
  _product = null;
}

function pickOpt(btn, groupIdx) {
  document.querySelectorAll('.zeva-opt-btn[data-g="' + groupIdx + '"]').forEach(function(b) {
    b.classList.remove('sel');
  });
  btn.classList.add('sel');

  if (!_product) return;
  var sel = getSelectedOpts();
  if (sel && sel.every(function(o){ return o !== null; })) {
    var match = findVariant(sel);
    if (match) {
      document.getElementById('zevaModalPrice').textContent = 'R' + Math.round(match.price / 100);
    }
  }
}

function getSelectedOpts() {
  if (!_product) return null;
  return _product.options.map(function(_, gi) {
    var btn = document.querySelector('.zeva-opt-btn[data-g="' + gi + '"].sel');
    return btn ? btn.textContent.trim() : null;
  });
}

function findVariant(sel) {
  return _product.variants.find(function(v) {
    return sel.every(function(opt, i) {
      return v['option' + (i + 1)] === opt;
    });
  });
}

async function confirmVariant() {
  if (!_product) return;
  var sel = getSelectedOpts();
  if (!sel || sel.some(function(o){ return o === null; })) {
    document.getElementById('zevaModalError').style.display = 'block';
    return;
  }
  document.getElementById('zevaModalError').style.display = 'none';
  var match = findVariant(sel);
  if (!match) return;
  if (!match.available) {
    document.getElementById('zevaModalError').textContent = 'This combination is out of stock.';
    document.getElementById('zevaModalError').style.display = 'block';
    return;
  }
  try {
    await zevaAddToCart(match.id, 1);
    closeVariantModal();
    await refreshCart();
    openCartDrawer();
    showFlash();
  } catch(e) {
    alert(e.message || 'Could not add to cart.');
  }
}

// ── Product Page Variant Selection ────────────────────────────
var _pageVariants = null;

function initProductPage(variants) {
  _pageVariants = variants;
  updateProductPrice();
}

function pickPageVariant(btn, groupIdx) {
  document.querySelectorAll('.product-variant-btn[data-g="' + groupIdx + '"]').forEach(function(b) {
    b.classList.remove('active');
  });
  btn.classList.add('active');
  updateProductPrice();
}

function getPageVariantSel() {
  if (!_pageVariants) return null;
  var groups = document.querySelectorAll('.product-variant-group');
  var sel = [];
  groups.forEach(function(_, i) {
    var btn = document.querySelector('.product-variant-btn[data-g="' + i + '"].active');
    sel.push(btn ? btn.textContent.trim() : null);
  });
  return sel;
}

function findPageVariant() {
  if (!_pageVariants) return null;
  var sel = getPageVariantSel();
  if (!sel || sel.some(function(o){ return o === null; })) return null;
  return _pageVariants.find(function(v) {
    return sel.every(function(opt, i) {
      return v['option' + (i + 1)] === opt;
    });
  });
}

function updateProductPrice() {
  var match = findPageVariant();
  var priceEl = document.getElementById('productPrice');
  if (priceEl && match) priceEl.textContent = 'R' + Math.round(match.price / 100);
}

async function addPageToCart() {
  var errEl = document.getElementById('productAddErr');
  if (_pageVariants && _pageVariants.length > 1) {
    var match = findPageVariant();
    if (!match) {
      if (errEl) { errEl.textContent = 'Please select all options.'; errEl.style.display = 'block'; }
      return;
    }
    if (!match.available) {
      if (errEl) { errEl.textContent = 'This option is out of stock.'; errEl.style.display = 'block'; }
      return;
    }
    if (errEl) errEl.style.display = 'none';
    try {
      await zevaAddToCart(match.id, 1);
    } catch(e) { alert(e.message); return; }
  } else if (_pageVariants && _pageVariants.length === 1) {
    try {
      await zevaAddToCart(_pageVariants[0].id, 1);
    } catch(e) { alert(e.message); return; }
  }
  await refreshCart();
  openCartDrawer();
  showFlash();
}

// ── Filter System ─────────────────────────────────────────────
var SEO_DESCRIPTIONS = {
  'all':        "Browse ZEVA's complete luxury collection — skincare, beauty tools, wellness and winter warmth products. All products tested by South African women, for women. Free shipping on orders over R1,000 delivered to all 9 provinces.",
  'winter':     "Stay warm in luxury this winter. Shop ZEVA's double-sided faux fur blankets, slipper boots and winter warmth products. Premium quality — free shipping on orders over R1,000 nationwide.",
  'skincare':   "Treat your skin with ZEVA's curated luxury skincare range. From collagen eye masks to pimple patches — scientifically backed skincare products trusted by South African women.",
  'tools':      "Professional beauty results at home. ZEVA's beauty tool range includes 7-in-1 facial and neck massagers, blackhead removal kits and precision skincare devices.",
  'wellness':   "ZEVA's wellness range covers full-body self-care: collagen body firming oil, teeth whitening strips and premium wellness products for South African women.",
  'featured':   "ZEVA's hand-picked luxury favourites — the products our customers love most, tested by South African women and selected for exceptional quality.",
  'bestseller': "South Africa's most-loved luxury products. ZEVA's best sellers are tried, tested and trusted by thousands of South African women.",
  'new':        "The newest additions to the ZEVA luxury collection. Fresh arrivals in skincare, beauty tools and wellness — be the first to discover what's new."
};

function filterProducts(category, btn) {
  document.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('active'); });
  if (btn) btn.classList.add('active');

  var cards = document.querySelectorAll('.product-card');
  var visible = 0;

  cards.forEach(function(card) {
    var cat  = card.dataset.category || '';
    var tags = (card.dataset.tags || '').split(' ');
    var show = false;

    if (category === 'all') {
      show = true;
    } else if (category === 'featured' || category === 'bestseller') {
      show = tags.indexOf(category) > -1;
    } else if (category === 'new') {
      show = tags.indexOf('new') > -1 || tags.indexOf('new-arrival') > -1;
    } else {
      show = cat === category;
    }

    card.style.display = show ? '' : 'none';
    if (show) visible++;
  });

  var noRes = document.getElementById('noResults');
  if (noRes) noRes.style.display = visible === 0 ? 'block' : 'none';

  var strip = document.getElementById('seoCatText');
  if (strip && SEO_DESCRIPTIONS[category]) strip.textContent = SEO_DESCRIPTIONS[category];

  if (typeof window.zevaSetCategory === 'function') window.zevaSetCategory(category);
}

// ── FAQ Accordion ─────────────────────────────────────────────
function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
}

// ── Product Thumbnail Gallery ─────────────────────────────────
function switchMainImg(src, thumb) {
  var main = document.getElementById('productMainImg');
  if (main) main.src = src;
  document.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
  if (thumb) thumb.classList.add('active');
}

// ── Init ─────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  zevaGetCart().then(function(cart) { updateBadge(cart); }).catch(function() {});

  var allBtn = document.querySelector('[data-filter="all"]');
  if (allBtn) filterProducts('all', allBtn);

  initFaq();
});